import * as React from 'react';
import { observable, computed } from "mobx";
import { observer } from "mobx-react";
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";
import { ContractSimulatorView } from './contract-simulator.view';
import { FormatService } from 'src/core/services/format.service';
import { ControllerProps } from 'src/router';
import { ConfigurationService } from 'src/core/services/configuration.service';

interface State {
	mode: ControlMode;
	defaultLanguage?: string;
}
@observer
export class ContractSimulatorController extends React.Component<ControllerProps<any>, State> {


	@resolve
	formatService: FormatService;

	@resolve
	configurationService: ConfigurationService;

	public constructor(props) {
		super(props);
		this.state = {
			mode: 'edit'
		};
	}
	componentDidMount() {
		this.props.setBusy(true);
		this.loadConfiguration()

	}

	private async loadConfiguration(): Promise<void> {
		const appConfiguration = await this.configurationService.current();
		this.setState({
			defaultLanguage: appConfiguration.defaultLanguage
		});

	}
	render() {
		if (this.state.defaultLanguage == null) return null;
		return (
			<div className="window window-normal">
				<ContractSimulatorView
					mode='display'
					disabled={false}
					defaultLanguage={this.state.defaultLanguage}
					formatService={this.formatService}
					setBusy={this.props.setBusy}
					model={null}
					defaultMarket={null}
					product={null}
					breadcrumb={null}

				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contractSimulator/contract-simulator.controller.tsx